import React from 'react';
import { useTranslations } from 'next-intl';

import {
  IOffer,
  RecommendedCentersCard,
} from 'modules/learning-centers';

interface IProps {
  recommendedCenters?: IOffer[];
}

const CenterRecommendation: React.FC<IProps> = ({ recommendedCenters }) => {
  const t = useTranslations();

  return (
    <div className="rounded-xl bg-white p-4">
      <div className="flex items-center justify-between">
        <p className="font-regular">{t('tavsiya_etiladigon_oquv_markazlar')}</p>
      </div>
      <div className="mt-3 space-y-2">
        {recommendedCenters?.map(offer => <RecommendedCentersCard key={offer?.id} offer={offer} />)}
      </div>
    </div>
  );
};

export default CenterRecommendation;
